import FormControlLabel from "@mui/material/FormControlLabel";
import { type SwitchProps as SwitchPropsMui } from "@mui/material/Switch";
import { isEmpty } from "lodash";
import { ReactNode, type FC } from "react";
import { useController } from "react-hook-form";
import * as StyledCommon from "./Common.styled";
import { FormError } from "./FormError";
import * as Styled from "./Switch.styled";

export type SwitchProps = SwitchPropsMui & {
    name: string;
    disabled?: boolean;
    label?: string;
    subLabel?: ReactNode;
};

export const SwitchInput: FC<SwitchProps> = ({ name, label, subLabel, ...rest }) => {
    const { fieldState, field } = useController({ name });
    const { error } = fieldState;

    return (
        <StyledCommon.InputRootWrapper>
            <StyledCommon.InputControlWrapper>
                <FormControlLabel
                    label={label}
                    control={
                        <Styled.Switch
                            disableRipple
                            id={`${name}-name`}
                            {...rest}
                            checked={!!field.value}
                            onChange={(e, checked) => field.onChange(checked)}
                            onBlur={field.onBlur}
                            name={field.name}
                            inputRef={field.ref}
                        />
                    }
                />
                {!isEmpty(subLabel) && (
                    <label htmlFor={`${name}-name`}>
                        <StyledCommon.InputLabel variant="subLabel">{subLabel}</StyledCommon.InputLabel>
                    </label>
                )}
            </StyledCommon.InputControlWrapper>
            <FormError error={error} fieldName={name} />
        </StyledCommon.InputRootWrapper>
    );
};
